module.exports = __webpack_public_path__ + "static/media/left_sustain.37926f69.png";